import React, { memo, forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ChannelPinterestIcon = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 16 16"
      >
        <path
          d="M0 7.99991C0 11.2757 1.96987 14.0899 4.78867 15.3271C4.76617 14.7685 4.78467 14.0979 4.92792 13.4901C5.08173 12.8407 5.95729 9.131 5.95729 9.131C5.95729 9.131 5.70173 8.6202 5.70173 7.86529C5.70173 6.67976 6.38885 5.79434 7.2446 5.79434C7.97228 5.79434 8.32384 6.34089 8.32384 6.99537C8.32384 7.72685 7.85728 8.82101 7.61734 9.83442C7.41691 10.683 8.04284 11.3752 8.88003 11.3752C10.3958 11.3752 11.4166 9.42843 11.4166 7.12187C11.4166 5.36854 10.2357 4.0562 8.08778 4.0562C5.66104 4.0562 4.14923 5.8659 4.14923 7.88735C4.14923 8.58433 4.35473 9.07582 4.67661 9.45643C4.82461 9.63124 4.84517 9.70155 4.79161 9.90229C4.75323 10.0495 4.66511 10.4038 4.62861 10.5443C4.57536 10.7469 4.41117 10.8193 4.22805 10.7445C3.1103 10.2882 2.58974 9.06419 2.58974 7.68823C2.58974 5.41573 4.50636 2.6908 8.30734 2.6908C11.3617 2.6908 13.372 4.90099 13.372 7.27349C13.372 10.4117 11.6273 12.7562 9.0554 12.7562C8.19172 12.7562 7.37928 12.2894 7.10097 11.7591C7.10097 11.7591 6.63654 13.6023 6.53816 13.9582C6.36854 14.575 6.03654 15.1915 5.73298 15.6719C6.45247 15.8843 7.21253 16 8.00028 16C12.418 16 16 12.4183 16 7.99991C16 3.58171 12.418 0 8.00028 0C3.58211 0 0 3.58171 0 7.99991Z"
          fill="#F7F9FD"
        />
      </SvgIcon>
    );
  })
);
